import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.WORD_SLIDE;

export const DIMENSIONS = {
  WIDTH: 1024,
  HEIGHT: 576,
};

export const MASTERY_VALUE = 0.8;

// PracticeButton's card exit animation (correct answer -> both cards off screen).
// Shared with practiceSequences.js so the next word pair isn't mounted mid-exit.
export const PRACTICE_CARD_EXIT_DELAY = 1500;
export const PRACTICE_CARD_EXIT_STAGGER = 100;
export const PRACTICE_CARD_EXIT_TRANSITION_DURATION = 700;
export const PRACTICE_CARD_EXIT_TOTAL_DURATION =
  PRACTICE_CARD_EXIT_DELAY + PRACTICE_CARD_EXIT_STAGGER + PRACTICE_CARD_EXIT_TRANSITION_DURATION;

export const CELL_WIDTH = 130;
export const CELL_HEIGHT = 113;

export const MIN_MARGIN_RIGHT = 10;

export const MAX_CELLS_TO_BE_CENTRED = 5;
export const CELL_PADDING = {
  MIN: 20,
  MAX: 40,
};

export const DIRECTION = {
  DIRECT: 1,
  REVERSE: -1,
};

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD: 'STANDARD',
  INSTRUCTION: 'INSTRUCTION',
  PRACTICE: 'PRACTICE',
  ONBOARDING: 'ONBOARDING',
  LOADING: 'LOADING',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  SET_LEVEL: 'SET_LEVEL',
  SET_QUESTION: 'SET_QUESTION',
  SET_QUESTION_DATA: 'SET_QUESTION_DATA',
  MOVE_TILE_TO: 'MOVE_TILE_TO',
  ENABLE_CONFIRMATION_BUTTON: 'ENABLE_CONFIRMATION_BUTTON',
  DISABLE_CONFIRMATION_BUTTON: 'DISABLE_CONFIRMATION_BUTTON',
  SET_CONFIRMATION_BUTTON_POSITION: 'SET_CONFIRMATION_BUTTON_POSITION',
  SET_QUESTION_PHASE: 'SET_QUESTION_PHASE',
  SET_ALEX_STATE: 'SET_ALEX_STATE',
  SET_SPEAKER_STATE: 'SET_SPEAKER_STATE',
  SET_FILL_COLOR_INDEX: 'SET_FILL_COLOR_INDEX',
  SET_SHOW_INCORRECT_FILL: 'SET_SHOW_INCORRECT_FILL',
  SET_SHOW_INCORRECT_BORDER: 'SET_SHOW_INCORRECT_BORDER',
  INCREASE_ATTEMPTS: 'INCREASE_ATTEMPTS',
  SET_SLIDER_GHOST_CELL_STATE: 'SET_SLIDER_GHOST_CELL_STATE',
  RESET_CORRECT_WITH_SPECIAL_CELL_IN_ROW: 'RESET_CORRECT_WITH_SPECIAL_CELL_IN_ROW',
  INCREASE_CORRECT_WITH_SPECIAL_CELL_IN_ROW: 'INCREASE_CORRECT_WITH_SPECIAL_CELL_IN_ROW',
  INCREASE_CORRECT_ANSWERS_COUNT: 'INCREASE_CORRECT_ANSWERS_COUNT',
  GET_NEXT_PRACTICE_ITEM: 'GET_NEXT_PRACTICE_ITEM',
  SET_PRACTICE_WAS_INCORRECT: 'SET_PRACTICE_WAS_INCORRECT',
  SET_IS_ONBOARDING_COMPLETED: 'SET_IS_ONBOARDING_COMPLETED',
  SET_HIGHEST_LEVEL_EARNED: 'SET_HIGHEST_LEVEL_EARNED',
  INCREASE_PROGRESS: 'INCREASE_PROGRESS',
  DROP_CELL_IN: 'DROP_CELL_IN',
  DROP_CELL_OUT: 'DROP_CELL_OUT',
  QUICK_ROUND: 'QUICK_ROUND',
  SET_ROUND_IS_COMPLETE: 'SET_ROUND_IS_COMPLETE',
  FADE_OUT_GLOW: 'FADE_OUT_GLOW',
};

export const QUESTION_PHASES = {
  DROP_IN: 'DROP_IN',
  INTERACTION: 'INTERACTION',
  BORDER_SPIN: 'BORDER_SPIN',
  BORDER_FILL_CORRECT: 'BORDER_FILL_CORRECT',
  BORDER_FILL_INCORRECT: 'BORDER_FILL_INCORRECT',
  CELL_FILL: 'CELL_FILL',
  ANIMATE_BG: 'ANIMATE_BG',
  GLOW_SPECIAL_CELL: 'GLOW_SPECIAL_CELL',
  LASERS: 'LASERS',
  DROP_DISTRACTOR_CELL: 'DROP_DISTRACTOR_CELL',
  DROP_SILENT_E_CELL_IN: 'DROP_SILENT_E_CELL_IN',
  DROP_OUT: 'DROP_OUT',
  ONBOARDING_DROP_IN: 'ONBOARDING_DROP_IN',
  ONBOARDING_ANIMATIONS: 'ONBOARDING_ANIMATIONS',
  ONBOARDING_GLOW_1: 'ONBOARDING_GLOW_1',
  ONBOARDING_GLOW_2: 'ONBOARDING_GLOW_2',
  ONBOARDING_GLOW_3: 'ONBOARDING_GLOW_3',
  ONBOARDING_GLOW_4: 'ONBOARDING_GLOW_4',
  ONBOARDING_GLOW_5: 'ONBOARDING_GLOW_5',
  ONBOARDING_BORDER_FILL: 'ONBOARDING_BORDER_FILL',
  ONBOARDING_CELL_FILL: 'ONBOARDING_CELL_FILL',
  INSTRUCTION_RL_GLOW_1: 'INSTRUCTION_RL_GLOW_1',
  INSTRUCTION_RL_GLOW_2: 'INSTRUCTION_RL_GLOW_2',
};

export const SPEAKER_STATES = {
  INACTIVE: 0,
  ACTIVE: 1,
};

export const BORDER = {
  TYPES: {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    TOP: 'TOP',
    BOTTOM: 'BOTTOM',
  },
  COLORS: [
    // filler taking the place of the removed #7DAEBF entry — kept as a duplicate rather than
    // shortening the array, since every index up to sectionCount - 1 (max 14) must stay populated
    { main: '#F5AB47', lighter: '#F5D1A0', laser: '#F68F04' },
    { main: '#00E499', lighter: '#BBF2E0', laser: '#00D38E' },
    { main: '#2709BA', lighter: '#E5DFFF', laser: '#5A3AFF' },
    { main: '#D009E5', lighter: '#F9D4FD', laser: '#C703DC' },
    { main: '#F5AB47', lighter: '#F5D1A0', laser: '#F68F04' },
    { main: '#98FA68', lighter: '#EBFCE2', laser: '#43CC00' },
    { main: '#F24444', lighter: '#FFDCDC', laser: '#FF1616' },
    { main: '#4990E2', lighter: '#DFEEFF', laser: '#0076FF' },
    { main: '#F4CC44', lighter: '#FDF2CD', laser: '#FFC500' },
    { main: '#6870FD', lighter: '#B4CCFF', laser: '#454FF2' },
    { main: '#D009E5', lighter: '#F9D4FD', laser: '#C703DC' },
    { main: '#F5AB47', lighter: '#F5D1A0', laser: '#F68F04' },

    // added for cases where sectionCount is > 12
    { main: '#F5AB47', lighter: '#F5D1A0', laser: '#F68F04' },
    { main: '#F5AB47', lighter: '#F5D1A0', laser: '#F68F04' },
  ],
  INCORRECT_COLOR_INDEX: 6, // index of COLORS entry used for incorrect-answer border fill (#F24444)
  ONBOARDING: { main: '#6a72fb', glow: '#45a5fc', fill: '#7aaafd' },
  WIDTH: 8, // border width
  H_WIDTH: 4, // halph width
  HEIGHT: 121, // border section height
};

export const GHOST_CELL_STATES = {
  NO: 'NO',
  INCLUDES: 'INCLUDES',
  INCLUDED: 'INCLUDED',
};

export const ITEM_TYPE = {
  SILENT_E: 'isSilentE',
  R_CONTROLLED: 'isRControlled',
  L_CONTROLLED: 'isLControlled',
  INFLECTED_ENDING: 'isInflectedEnding',
};
